<template>
  <div v-if="dataIsLoad" :class="isMobile ? 'product-photos__jumbo' : 'product-photos__images'">
    <div v-if="photoCover" class="position-relative" @click="zoomImg(0, $event)">
      <NewImage
        v-if="isMobile"
        :url="selectedProductImg[0].Url"
        :size="'_w886_h1128'"
        :name="itemDatas.Name"
      />
      <NewImage v-else :url="selectedProductImg[0].Url" :size="''" :name="itemDatas.Name" />
    </div>
    <template v-else>
      <div
        v-for="(item, index) in selectedProductImg"
        :key="image + index"
        class="position-relative"
        @click="zoomImg(index, $event)"
      >
        <i
          v-if="item.VideoUrl"
          class="icon-play d-md-inline-block d-none"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -30px;
            margin-left: -30px;
            background-size: 60px;
            background-position: center;
            z-index: 1;
          "
        />
        <i
          v-if="item.VideoMUrl"
          class="icon-play d-md-none d-inline-block"
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            margin-top: -30px;
            margin-left: -30px;
            background-size: 60px;
            background-position: center;
            z-index: 1;
          "
        />
        <NewImage v-if="isMobile" :url="item.Url" :size="'_w886_h1128'" :name="itemDatas.Name" />
        <NewImage v-else :url="item.Url" :size="''" :name="itemDatas.Name" />
      </div>
    </template>
  </div>
</template>

<script>
import NewImage from '@global/components/global/image';
import zoomBox from '@global/components/product_vue/zoombox';
import imgTransfer from '@global/helpers/imgTransfer';
import setEnv from '@global/helpers/setEnv';
import { mapState } from 'vuex';

export default {
  name: 'ProductPhoto',
  components: {
    NewImage,
  },
  props: {
    photoCover: {
      type: Boolean,
    },
  },
  data() {
    return {
      isMobile: setEnv.myEquipment(),
    };
  },
  computed: {
    ...mapState('shopContent', ['itemDatas', 'dataIsLoad', 'selectedData']),
    selectedProductImg() {
      return this.selectedData.Images.filter((data) => data.Category === 0);
    },
  },
  methods: {
    zoomImg(index, event) {
      const data = [];

      this.selectedData.Images.forEach((element) => {
        if (element.Category === 0) data.push(element);
      });

      const newData = data.map((ele) => {
        if (ele.VideoUrl.length !== 0 || ele.VideoMUrl.length !== 0) {
          // 有影片
          return this.isMobile
            ? imgTransfer(ele.VideoMUrl.length !== 0 ? ele.VideoMUrl : ele.Url, '')
            : imgTransfer(ele.VideoUrl.length !== 0 ? ele.VideoUrl : ele.Url, '');
        }
        return this.isMobile ? imgTransfer(ele.Url, '_w886_h1128') : imgTransfer(ele.Url, '');
      });

      zoomBox({
        images: JSON.parse(JSON.stringify(newData)),
        index,
        yPos: event.pageY - window.scrollY,
        tilting: true,
      });
    },
  },
};
</script>
